export const Statuses = {
    INITIALIZED: "INITIALIZED",
    SUBMITTED: "SUBMITTED",
    CANCELED: "CANCELED",
    APPROVED: "APPROVED",
    SENT_TO_SUPPLIER: "SENT_TO_SUPPLIER",
    RECEIVED: "RECEIVED",
    NOT_DELIVERED: "NOT_DELIVERED",
    PENDING: "PENDING",
    MODIFIED: "MODIFIED",
    REJECTED: "REJECTED",
    ACCEPTED: "ACCEPTED",
    IN_PREPARATION: "IN_PREPARATION",
    PREPARED: "PREPARED",
    SHIPPED: "SHIPPED",
    RECEIVED_BY_CUSTOMER: "RECEIVED_BY_CUSTOMER",
    INVOICED: "INVOICED"
};